import { Accept } from "react-dropzone";

import { ProgressBarVariant } from "@gx/dls/metrics/ProgressBar";

import { CREATE_SOURCE_FAILED_TO_CREATE_ERROR_HEADER } from "@/pages/sources/components/create/sources/constants";
import {
  CreateSourceFileUploadOperation,
  CreateSourceFileUploadPhase,
} from "@/pages/sources/components/create/sources/file-upload/types";

export const SOURCE_FILE_UPLOAD_CONFIGURATION_CASE = "sourceFileUpload";

// TODO: (@leonkozlowski) uncomment when structured files are supported
export const SOURCE_FILE_UPLOAD_ACCEPTED_FILE_TYPES: Accept = {
  // "text/csv": [".csv"],
  // "application/csv": [".csv"],
  // "text/comma-separated-values": [".csv"],
  "application/pdf": [".pdf"],
  "text/plain": [".txt"],
  "text/markdown": [".md"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
  // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  // "application/vnd.ms-excel": [".xls"],
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.ms-word": [".doc"],
};

export const CREATE_SOURCE_FILE_UPLOAD_PHASE_TO_PROGRESS_BAR_VARIANT_MAP: Record<
  CreateSourceFileUploadPhase,
  ProgressBarVariant
> = {
  [CreateSourceFileUploadPhase.CREATING_SOURCE]: ProgressBarVariant.PRIMARY,
  [CreateSourceFileUploadPhase.COMPLETED]: ProgressBarVariant.SUCCESS,
  [CreateSourceFileUploadPhase.ERROR]: ProgressBarVariant.ERROR,
  [CreateSourceFileUploadPhase.IDLE]: ProgressBarVariant.PRIMARY,
  [CreateSourceFileUploadPhase.UPLOADING]: ProgressBarVariant.PRIMARY,
};

export const CREATE_SOURCE_FILE_UPLOAD_OPERATION_STEP_TO_PHASE_MAP: Record<
  CreateSourceFileUploadOperation,
  CreateSourceFileUploadPhase
> = {
  [CreateSourceFileUploadOperation.CREATE_SOURCE]: CreateSourceFileUploadPhase.CREATING_SOURCE,
  [CreateSourceFileUploadOperation.UPLOAD_FILES]: CreateSourceFileUploadPhase.UPLOADING,
};

export const CREATE_SOURCE_FILE_UPLOAD_UPLOAD_FAILED_ERROR_HEADER = "Upload failed";

export const CREATE_SOURCE_FILE_UPLOAD_OPERATION_STEP_TO_ERROR_TOAST_HEADER_MAP: Record<
  CreateSourceFileUploadOperation,
  string
> = {
  [CreateSourceFileUploadOperation.CREATE_SOURCE]: CREATE_SOURCE_FAILED_TO_CREATE_ERROR_HEADER,
  [CreateSourceFileUploadOperation.UPLOAD_FILES]:
    CREATE_SOURCE_FILE_UPLOAD_UPLOAD_FAILED_ERROR_HEADER,
};
